import { render, staticRenderFns } from "./MovePassengers.vue?vue&type=template&id=1eeb9586&"
import script from "./MovePassengers.vue?vue&type=script&lang=js&"
export * from "./MovePassengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports